import React from 'react';
import PropTypes from 'prop-types';

import { NotificationTypes } from './constants';

import * as styles from './styles.css';

function classNamesForType(type) {
  switch (type) {
    case (NotificationTypes.ERROR):
      return 'alert-danger';

    case (NotificationTypes.WARNING):
      return 'alert-warning';

    default:
      return 'alert-success';
  }
}

const icons = {
  [NotificationTypes.ERROR]: 'fa-exclamation-circle',
  [NotificationTypes.WARNING]: 'fa-exclamation-triangle',
};

export default function Notification({ type, message, children, inline, icon }) {
  const notificationIcon = icon || icons[type];
  return (
    <div
      className={`alert ${classNamesForType(type)} ${(!inline && styles.borders) || ''}`}
      data-testid={`Notification-${type}`}
    >
      <div className={styles.notificationHeader}>
        <h4>
          {notificationIcon && <i className={`fa fa-lg ${notificationIcon}`} />}
          {message}
        </h4>
      </div>
      {children && (
        <div className={styles.notificationBody}>
          {children}
        </div>
      )}
    </div>
  );
}

Notification.defaultProps = {
  inline: false,
  type: undefined,
  children: undefined,
  icon: undefined,
};

Notification.propTypes = {
  message: PropTypes.string.isRequired,
  type: PropTypes.oneOf(Object.values(NotificationTypes)),
  children: PropTypes.node,
  icon: PropTypes.string,
  inline: PropTypes.bool,
};
